import React, {useRef} from "react";

import LookCanvas from "./lookCanvas";
import LookSidebar from "./lookNavigation/lookSideBar/lookSideBar";
import LookMain from "./lookNavigation/lookMain/lookMain";
// import LookIntroNavigateAnchor from "./lookNavigation/lookIntro/lookIntroNavigateAnchor";
import WithZoomToFeature from "./hocs/withZoomToFeature";
import LookCanvasContext from "./lookCanvasContext";
import LookRouting from "./lookRouting";
import LookIntro from "./lookNavigation/lookIntro/lookIntro";
import GroheCartRoutes from "./grohe/groheCart/groheCartRoutes";
import ShopPage from "./shop/shopPage";
import LookLockedOverlay from "./popups/lockedOverlay/lookLockedOverlay";
import LookFixedButtons from "./lookFixedButtons";
import LookNotInVisualizerPopper from "./lookNavigation/lookNotInVisualizerPopper";


const LookComponents = (props) => {

  const {allowRouting} = props;
  const imageCanvas = useRef();

  return (
    <LookCanvasContext.Provider value={imageCanvas}>
      <div className="wrapper">
        <WithZoomToFeature imageCanvas={imageCanvas}>
          {(zoomToFeatureGroup) => <LookCanvas imageCanvas={imageCanvas} zoomToFeatureGroup={zoomToFeatureGroup} />}
        </WithZoomToFeature>
        <LookNotInVisualizerPopper/>
        {/*<LoaderView/> //TODO */}
      </div>
      <LookLockedOverlay/>
      <LookFixedButtons/>
      <ShopPage/>
      <GroheCartRoutes/>
      {/*<LookIntroNavigateAnchor/>*/}
      <LookSidebar imageCanvas={imageCanvas}/>
      <LookMain/>
      {allowRouting ? (
        <WithZoomToFeature imageCanvas={imageCanvas}>
          {(zoomToFeatureGroup) => <LookRouting imageCanvas={imageCanvas} zoomToFeatureGroup={zoomToFeatureGroup} />}
        </WithZoomToFeature>
      ) : null}
      <LookIntro/>
    </LookCanvasContext.Provider>
  )
};

export default LookComponents
